export var MotionState;
(function (MotionState) {
    MotionState["Opening"] = "opening";
    MotionState["Closing"] = "closing";
    MotionState["Opened"] = "opened";
    MotionState["Closed"] = "closed";
})(MotionState || (MotionState = {}));
